/**
 * Created by Christof Sander on 01.07.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		resourceRegisterKey: 'options'
	}
};
